<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('dailyExpense.date') }}</label>
            <a-date-picker
              class="ts-w-full"
              v-model="model.exp_date"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
            ></a-date-picker>
            <div
              class="validate ts-text-xs"
              v-if="errors.has('exp_date')"
            >{{ errors.first('exp_date') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('dailyExpense.expenseItem') }}</label>
            <a-select
              v-model="model.exp_id"
              class="ts-w-full"
              :options="expenseItems"
              showSearch
              :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
            ></a-select>
            <div
              class="validate ts-text-xs"
              v-if="errors.has('exp_id')"
            >{{ errors.first('exp_id') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('dailyExpense.currency') }}</label>
            <a-select
              v-model="model.currency_id"
              class="ts-w-full"
              :options="currencies"
              showSearch
              :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
            ></a-select>
            <div
              class="validate ts-text-xs"
              v-if="errors.has('currency_id')"
            >{{ errors.first('currency_id') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('dailyExpense.quantity') }}</label>
            <input
              v-model.number="model.exp_qty"
              type="number"
              step="any"
              class="form-control"
            >
            <div
              class="validate ts-text-xs"
              v-if="errors.has('exp_qty')"
            >{{ errors.first('exp_qty') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('dailyExpense.unitPrice') }}</label>
            <input
              v-model.number="model.exp_unit_price"
              type="number"
              step="any"
              class="form-control"
            >
            <div
              class="validate ts-text-xs"
              v-if="errors.has('exp_unit_price')"
            >{{ errors.first('exp_unit_price') }}</div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('dailyExpense.fxRate') }}</label>
            <input
              v-model.number="model.fx_rate"
              type="number"
              step="any"
              class="form-control"
              readonly
            >
            <div
              class="validate ts-text-xs"
              v-if="errors.has('fx_rate')"
            >{{ errors.first('fx_rate') }}</div>
          </div>
        </div> -->
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('dailyExpense.expenseBy') }}</label>
            <a-select
              v-model="model.expensed_by"
              class="ts-w-full"
              :options="employees"
              showSearch
              :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
            ></a-select>
            <div
              class="validate ts-text-xs"
              v-if="errors.has('expensed_by')"
            >{{ errors.first('expensed_by') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{ $t('dailyExpense.description') }}</label>
            <textarea
              v-model="model.exp_desc"
              rows="3"
              class="form-control"
            ></textarea>
            <div
              class="validate ts-text-xs"
              v-if="errors.has('exp_desc')"
            >{{ errors.first('exp_desc') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right ts-space-x-3">
            <ts-button @click.prevent="() => $emit('cancel')">
              {{
              $t('cancel')
              }}
            </ts-button>
            <ts-button
              v-if="!isUpdate"
              outline
              color="primary"
              @click.prevent="saveAddNew"
              :waiting="waiting_new"
            >{{ $t('save_add_new') }}</ts-button>
            <ts-button
              v-if="!isUpdate"
              color="primary"
              @click.prevent="onSave"
              :waiting="waiting"
            >{{ $t('save') }}</ts-button>
            <ts-button
              v-if="isUpdate"
              color="primary"
              @click.prevent="onUpdate"
              :waiting="waiting"
            >{{ $t('update') }}</ts-button>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'companyForm',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_new: false,
      currencies: [],
      expenseItems: [],
      employees: [],
      model: {
        tran_id: null,
        exp_id: null,
        exp_date: moment().format('DD-MM-YYYY'),
        currency_id: null,
        exp_qty: 1,
        exp_unit_price: null,
        exp_amount: null,
        exp_desc: null,
        fx_rate: 1,
        expensed_by: null,
      }
    }
  },
  created() {
    this.setEditData()
    this.fetchData()
  },
  computed: {
    ...mapState('expense/dailyExpense', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    ...mapActions('expense/dailyExpense', ['getCurrency', 'getExpenseItem', 'getEmployee']),
    async fetchData(){
      this.loading = true
      await this.getCurrency()
        .then(response => {
          this.currencies = response.data.map(el => ({
            value: el.currency_id,
            label: el.currency_code,
            is_default: el.is_default
          }))
          if(!this.isUpdate){
            const currency = this.currencies.find(e => e.is_default == true);
            this.model.currency_id = currency ? currency.value : null
          }

        })
      await this.getExpenseItem()
        .then(response => {
          this.expenseItems = response.data.map(el => ({
            value: el.exp_id,
            label: el.exp_item
          }))
        })
      await this.getEmployee()
        .then(response => {
          this.employees = response.data.map(el => ({
            value: el.employee_id,
            label: el.employee_name_en
          }))
        })
      this.loading = false
    },
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('expense/dailyExpense/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    saveAddNew() {
      this.waiting_new = true
      this.$store
        .dispatch('expense/dailyExpense/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('expense/dailyExpense/update', {
          id: this.model.tran_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.tran_id =  this.edit_data.tran_id
        this.model.exp_id =  this.edit_data.exp_id
        this.model.exp_date =  this.edit_data.exp_date
        this.model.currency_id =  this.edit_data.currency_id
        this.model.exp_qty =  this.edit_data.exp_qty
        this.model.exp_unit_price =  this.edit_data.exp_unit_price
        this.model.exp_amount =  this.edit_data.exp_amount
        this.model.exp_desc =  this.edit_data.exp_desc
        this.model.fx_rate =  this.edit_data.fx_rate
        this.model.expensed_by =  this.edit_data.expensed_by
      }
    },
    calculate(){
      this.model.exp_amount = this.model.exp_unit_price * this.model.exp_qty
    },
    clearInput(){
      const currency = this.currencies.find(e => e.is_default == true);

      this.model.tran_id = null
      this.model.exp_id = null
      this.model.exp_date = moment().format('DD-MM-YYYY')
      this.model.currency_id = currency ? currency.value : null
      this.model.exp_qty = 1
      this.model.exp_unit_price = null
      this.model.exp_amount = null
      this.model.exp_desc = null
      this.model.fx_rate =  1
      this.model.expensed_by = null
    }
  },
  watch: {
    model: {
      handler(value){
        this.calculate()
      },
      deep: true
    }
  }
}
</script>
